export enum CardInvoiceStyle {
  base = 'base',
  customized = 'customized',
}
